import { useEffect } from 'react';
import { Link } from 'react-router';
import { useLayoutSlots } from '@app/layouts/layoutContext';
import styles from './textPages.module.css';

export function NotFoundRoute() {
  const { setCenter, setRight } = useLayoutSlots();
  useEffect(() => {
    setCenter(
      <article className={styles.page}>
        <h1>Page not found</h1>
        <p>
          That URL doesn't exist. <Link to="/">Back to the Circle</Link>.
        </p>
      </article>,
    );
    setRight(null);
    return () => {
      setCenter(null);
      setRight(null);
    };
  }, [setCenter, setRight]);
  return null;
}
